.container {
    padding: 4rem 0 0;
    text-align: center;
}

.heading {
    font-size: 2.75rem;
}

.button {
    display: inline-block;
    margin: 1rem 0;
}
